import IconArrowLeft from '@assets/images/icons/icon-arrow-left-black.svg';

import { HEADER_STRINGS } from '../../utils/header.constants';

import { useBackButtonLogic } from './back-button.hook';

const BackButton = () => {
	const { handleClick } = useBackButtonLogic();

	return (
		<button type="button" data-qa="back-to-chat-list" onClick={handleClick}>
			<img
				src={IconArrowLeft}
				alt={HEADER_STRINGS.BACK_ALT}
				height="24"
				width="24"
			/>
		</button>
	);
};

BackButton.displayName = 'BackButton';
export { BackButton };
